import type { MessageDraft } from './localStore';
import { maskEmail, maskPhone } from './localStore';

export function buildJoinUrl(draft: MessageDraft): string {
  const base =
    typeof window !== 'undefined'
      ? `${window.location.origin}/join`
      : 'https://itoldyouso.app/join';
  const params = new URLSearchParams();
  if (draft.recipient?.emailHint) {
    params.set('ehint', draft.recipient.emailHint);
  }
  if (draft.recipient?.phoneHint) {
    params.set('phint', draft.recipient.phoneHint);
  }
  params.set('ref', draft.id);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export function buildShareText(draft: MessageDraft, joinUrl: string): string {
  const lines = ['I left you a note on iToldYouSo.'];
  if (draft.recipient?.emailHint) {
    lines.push(`Sign up with email like: ${draft.recipient.emailHint}`);
  }
  if (draft.recipient?.phoneHint) {
    lines.push(`Or phone ending in: ${draft.recipient.phoneHint}`);
  }
  lines.push(joinUrl);
  return lines.join('\n');
}

export function recipientFromFields(
  name: string,
  email: string,
  phone: string
): MessageDraft['recipient'] | undefined {
  const trimmedEmail = email.trim();
  const trimmedPhone = phone.trim();
  const trimmedName = name.trim();
  if (!trimmedEmail && !trimmedPhone && !trimmedName) return undefined;
  return {
    name: trimmedName || undefined,
    email: trimmedEmail || undefined,
    phone: trimmedPhone || undefined,
    emailHint: trimmedEmail ? maskEmail(trimmedEmail) : undefined,
    phoneHint: trimmedPhone ? maskPhone(trimmedPhone) : undefined,
  };
}

export function emailMatchesHint(email: string, hint: string): boolean {
  return maskEmail(email) === hint.trim().toLowerCase();
}

export function phoneMatchesHint(phone: string, hint: string): boolean {
  return maskPhone(phone) === hint.trim();
}
